import { Box, Button } from '@intech/web-ui';
import React, { useState } from 'react';
import { ExtratoCD } from '@entidades';
import { LoadingComponent } from '@components';
import { ExtratoReais } from './ExtratoReais';
import { ExtratoCotas } from './ExtratoCotas';

interface IProps {
  contribuicoes: Array<ExtratoCD> | null;
  periodo: string;
}

export const Contribuicoes: React.FC<IProps> = ({
  contribuicoes,
  periodo
}) => {
  const [ExtratoAtivo, setExtratoAtivo] = useState<"reais" | "cotas">("reais");

  if (contribuicoes !== null) {
    if (contribuicoes.length > 0) {
      return (
        <Box title={"Contribuições do Período"} badgeText={periodo}>

          <Button
            title={"Extrato em Reais"}
            type={ExtratoAtivo === "reais" ? "primary" : "light"}
            disabled={ExtratoAtivo === "reais"}
            onClick={() => setExtratoAtivo("reais")}
          />

          <Button
            title={"Extrato em Cotas"}
            type={ExtratoAtivo === "cotas" ? "primary" : "light"}
            disabled={ExtratoAtivo === "cotas"}
            onClick={() => setExtratoAtivo("cotas")}
          />

          {ExtratoAtivo === "reais" && <ExtratoReais contribuicoes={contribuicoes} />}

          {ExtratoAtivo === "cotas" && <ExtratoCotas contribuicoes={contribuicoes} />}
        </Box>
      );

    }
    return null;

  }
  return <LoadingComponent />;
}